<template>
  <div>
    <div v-if="item" class="table-responsive">
      <table class="table table-striped table-hover">
        <tbody>
          <tr>
            <td>{{$t('company.phone')}}</td>
            <td>
              <template v-for="contact, i in phones">
                <a :href="'tel:' + contact.value">{{contact.value}}</a><template v-if="i + 1 < phones.length">, </template>
              </template>
            </td>
          </tr>
          <tr>
            <td>{{$t('company.mobile')}}</td>
            <td>
              <template v-for="contact, i in mobiles">
                <a :href="'tel:' + contact.value">{{contact.value}}</a><template v-if="i + 1 < mobiles.length">, </template>
              </template>
            </td>
          </tr>
          <tr>
            <td>{{$t('company.email')}}</td>
            <td>
              <template v-for="contact, i in emails">
                <a :href="'mailto:' + contact.value">{{contact.value}}</a><template v-if="i + 1 < emails.length">, </template>
              </template>
            </td>
          </tr>
          <tr>
            <td>{{$t('company.www')}}</td>
            <td>
              <template v-for="contact, i in wwws">
                <a :href="fixContactWww(contact).value" target="_blank">{{contact.value}}</a><template v-if="i + 1 < wwws.length">, </template>
              </template>
            </td>
          </tr>
          <tr>
            <td>{{$t('company.contactPerson')}}</td>
            <td>{{ item['contactPerson'] }}</td>
          </tr>
          <tr>
              <td>{{$t('address.country.name')}}</td>
              <td><template v-if="item['country']">{{ item['country']['name'] }}</template></td>
          </tr>
          <tr>
              <td>{{$t('address.city.name')}}</td>
              <td><template v-if="item['city']">{{ item['city']['name'] }}</template></td>
          </tr>
          <tr>
              <td>{{$t('address.region')}}</td>
              <td>{{ item['region'] }}</td>
          </tr>
          <tr>
              <td>{{$t('address.district')}}</td>
              <td>{{ item['district'] }}</td>
          </tr>
          <tr>
              <td>{{$t('address.postCode')}}</td>
              <td>{{ item['postCode'] }}</td>
          </tr>
          <tr>
              <td>{{$t('address.street')}}</td>
              <td>{{ item['street'] }}</td>
          </tr>
          <tr>
              <td>{{$t('address.building')}}</td>
              <td>{{ item['building'] }}</td>
          </tr>
          <tr>
              <td>{{$t('address.apartment')}}</td>
              <td>{{ item['apartment'] }}</td>
          </tr>
          <tr>
            <td>{{$t('company.description')}}</td>
            <td>{{ item['description'] }}</td>
          </tr>
          <tr>
            <td>{{$t('company.comment')}}</td>
            <td>{{ item['comment'] }}</td>
          </tr>
          <tr>
            <td>{{$t('company.labels.id')}}</td>
            <td>
                <div v-for="label in item.labels">
                    <span class="label label-primary">{{label.name}}</span>
                </div>
            </td>
          </tr>
          <tr>
            <td>{{$t('company.createdAt')}}</td>
            <td>{{ moment(item['createdAt']).format('DD-MM-YYYY HH:mm') }}</td>
          </tr>
          <tr>
            <td>{{$t('company.updatedAt')}}</td>
            <td>{{ moment(item['updatedAt']).format('DD-MM-YYYY HH:mm') }}</td>
          </tr>
          <tr>
            <td>{{$t('company.updatedBy')}}</td>
            <td>{{ item['updatedBy'] }}</td>
          </tr>
          <tr>
            <td width="20%">{{$t('Images')}}</td>
            <div class="company-wrapper">
              <div class="company-wrapper__image" v-for="image in item.images" :key="image.id" >
                <img :src="imagePath(image, '200')" class="wp-post-image"  alt="" @click="showModalImage(image)">
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <modal-image v-if="isVisibleModalImage" @closeModalImage="closeModalImage"><img :src="image" style="width: -webkit-fill-available; max-height: 500px"></modal-image>
  </div>
</template>

<script>

import Image from '../../mixin/Image.vue'
import ModalImage from '../layout/ModalImage.vue'

  export default {
    components: {
      ModalImage
    },
    mixins: [Image],
    name: 'CompanyInfo',
    props: {
      item: null
    },
    data () {
      return {
        moment: moment,
        isVisibleModalImage: false
        
      }
    },
    computed: {
      phones () {
        return this.getContactsByType('Phone')
      },
      mobiles() {
        return this.getContactsByType('Mobile')
      },
      emails () {
        return this.getContactsByType('Email')
      },
      wwws () {
        return this.getContactsByType('WWW')
      }
    },
    methods: {
      showModalImage (image) {
        this.image = this.imagePath(image, '1000')
        this.isVisibleModalImage = true
      },
      closeModalImage() {
        this.isVisibleModalImage = false
      },
      getContactsByType (type) {
        return this.item.contacts.filter(function (contact) {
          return contact.contactType.name === type
        })
      },
      fixContactWww (contact) {
        if (!contact.value.includes('http')) {
          contact.value = 'http://' + contact.value
        }

        return contact
      }
    }
  }
</script>

<style >

  .company-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .company-wrapper__image {
    margin: 10px 10px 0 0;
  }


</style>

